import { Reveal } from "@/components/site/Reveal";
import { useContent } from "@/context/ContentContext";

export const Press = () => {
  const { content } = useContent();
  const PRESS = content.press;
  return null;
};
